import React, { ReactNode } from 'react';
import { InputContainer, InputStyled, ClearButton } from './styles';

type InputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  placeholderIcon?: ReactNode;
  disabled?: boolean;
  className?: string;
};

export const Input: React.FC<InputProps> = ({
  value,
  onChange,
  placeholder,
  placeholderIcon,
  disabled,
  className,
}) => {
  const handleClear = () => {
    onChange('');
  };

  return (
    <InputContainer>
      {placeholderIcon}
      <InputStyled
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
      />
      {value && !disabled && (
        <ClearButton onClick={handleClear} aria-label="Clear input">
          ✕
        </ClearButton>
      )}
    </InputContainer>
  );
};
